import { ITranslations } from 'types/common';
import { EntityTitleTransFields } from './types';
import en from 'translations/en/entityTitle.json';
import pl from 'translations/pl/entityTitle.json';
import sl from 'translations/sl/entityTitle.json';

export const entityTitleTranslations: ITranslations<EntityTitleTransFields> = {
  name: 'entityTitle',
  en,
  pl,
  sl,
};
